import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";

export function Brand({ className = "", onDark = false }) {
  return (
    <Link to="/" className={`flex flex-col leading-none ${className}`} data-testid="brand-logo">
      <span className={`text-eyebrow ${onDark ? "text-goldLight/80" : "text-gold"}`}>Mike &amp; Sam's</span>
      <span className={`font-serif text-lg sm:text-xl tracking-tight ${onDark ? "text-white" : "text-espresso"}`}>
        Friendsgiving
      </span>
    </Link>
  );
}

export function Nav({ onDark = false }) {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const loc = useLocation();
  const links = [
    { to: "/", label: "Invitation" },
    { to: "/#table", label: "The Table" },
    { to: "/#guests", label: "Who's Coming" },
  ];
  const go = (to) => {
    setOpen(false);
    if (to.startsWith("/#")) {
      if (loc.pathname !== "/") nav("/");
      setTimeout(() => document.querySelector(to.slice(1))?.scrollIntoView({ behavior: "smooth" }), 120);
    } else nav(to);
  };
  const textCol = onDark ? "text-white/85" : "text-ink/80";

  return (
    <header className={`sticky top-0 z-50 border-b ${onDark ? "border-white/10 bg-espressoDeep/70" : "border-hair bg-cream/80"} backdrop-blur-xl`}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Brand onDark={onDark} />
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button key={l.label} onClick={() => go(l.to)} className={`text-sm font-medium ${textCol} hover:text-gold transition-colors`} data-testid={`nav-${l.label.toLowerCase().replace(/[^a-z]/g, "-")}`}>
              {l.label}
            </button>
          ))}
          <button onClick={() => go("/my-rsvp")} className={`text-sm font-semibold ${onDark ? "text-goldLight" : "text-espresso"} hover:text-gold transition-colors`} data-testid="nav-my-rsvp">
            My RSVP
          </button>
          <button onClick={() => go("/rsvp")} className="gold-gradient text-espressoDeep text-sm font-bold px-5 py-2.5 rounded-full shadow-gold hover:brightness-105 active:scale-95 transition" data-testid="nav-rsvp-now">
            RSVP Now
          </button>
        </nav>
        <button className={`md:hidden ${onDark ? "text-white" : "text-espresso"}`} onClick={() => setOpen(!open)} data-testid="nav-menu-toggle" aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-hair bg-cream px-4 py-4 flex flex-col gap-1 animate-fade-in" data-testid="mobile-menu">
          {links.map((l) => (
            <button key={l.label} onClick={() => go(l.to)} className="text-left py-3 text-ink/80 font-medium border-b border-hair/60">{l.label}</button>
          ))}
          <button onClick={() => go("/my-rsvp")} className="text-left py-3 font-semibold text-espresso" data-testid="mobile-my-rsvp">My RSVP</button>
          <button onClick={() => go("/rsvp")} className="gold-gradient text-espressoDeep font-bold px-5 py-3 rounded-full mt-2" data-testid="mobile-rsvp-now">RSVP Now</button>
        </div>
      )}
    </header>
  );
}

export function Footer() {
  return (
    <footer className="border-t border-hair bg-cream2/60 mt-24">
      <div className="max-w-6xl mx-auto px-6 py-12 text-center">
        <p className="text-eyebrow text-gold">Mike &amp; Sam's</p>
        <p className="font-serif text-2xl text-espresso mt-1">Friendsgiving</p>
        <p className="text-inkSoft text-sm mt-3">November 14, 2026 · 2:00 PM EST</p>
        <Link to="/host" className="inline-block mt-6 text-xs text-inkMuted hover:text-gold transition-colors" data-testid="footer-host-link">
          Hosts · Sign in
        </Link>
      </div>
    </footer>
  );
}
